import React, { useContext, useEffect, useState, useMemo } from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import { personnelDetailContext } from "../../PersonnelDetail";
import BaseApi from "../../../../functions/axios";
import Select from "react-select";
import NonIconButton from "../../../../components/NonIconButton";
import { Grid, Typography } from "@mui/material";

export default function InterviewModal() {
  const {
    projectId,
    matchingIndex,
    personnelList = [],
    setOfferStatus,
    setOfferList,
    projectList = [],
  } = useContext(personnelDetailContext);

  const [message, setMessage] = useState("");
  const [requestedProjectForInterview, setRequestedProjectForInterview] =
    useState({ mail_subject: "", id: 0 });
  const [, setIsSend] = useState(false);

  const reversedProjectList = useMemo(() => [...projectList].reverse(), [projectList]);

  useEffect(() => {
    const index = projectList.findIndex((project) => project.id === projectId);
    if (index >= 0) {
      setRequestedProjectForInterview(projectList[index]);
    }
  }, [projectId, projectList]);

  const handleChangeProjectID = (selectedOption) => {
    setRequestedProjectForInterview(selectedOption || { mail_subject: "", id: 0 });
  };

  const getOfferList = async () => {
    const targetPersonnel = personnelList[matchingIndex];
    if (!targetPersonnel?.id) return;

    try {
      const res = await BaseApi.get("offer_history", {
        params: { personnel_id: targetPersonnel.id },
      });
      const resOfferList = res?.data?.data?.offer_list || [];
      
      if (resOfferList.length > 0) {
        setOfferList([...resOfferList]);
      } else {
        setOfferList([{ registed_at: "noOffer", bp_name: 0, memo: 0 }]);
      }

      const offerIndex = resOfferList.findIndex(
        (offer) =>
          projectList.findIndex((project) => project.id === offer.project_id) >= 0
      );

      if (offerIndex >= 0) {
        setOfferStatus({
          status: resOfferList[offerIndex].registed_at ? 2 : 1,
          index: offerIndex,
        });
      } else {
        setOfferStatus({ status: 0, index: offerIndex });
      }
    } catch (error) {
      console.error("getOfferList error:", error);
    }
  };

  const requestInterview = async () => {
    const targetPersonnel = personnelList[matchingIndex];
    if (!targetPersonnel?.id) return;

    try {
      const res = await BaseApi.post("regist_suggestion", {
        personnel_id: targetPersonnel.id,
        project_id: requestedProjectForInterview.id,
        message,
      });

      if (res?.data?.result === 0) {
        setOfferStatus({ status: 1, index: -1 });
        setIsSend(true);
        alert("打合せ希望を送信しました");
        getOfferList();
      } else {
        alert("打合せ希望を送信できませんでした");
      }
    } catch (error) {
      console.error("requestInterview error:", error);
      alert("エラーが発生しました");
    }
  };

  return (
    <Box sx={{ paddingTop: "20px", paddingBottom: "20px", width: "100%" }}>
      <Typography>
        この技術提供主(要員)との打合せをご希望の場合は、該当する募集情報（必須）と事務局への連絡を設定の上ボタンを押してください。
      </Typography>
      
      <Box sx={{ display: { xs: "block", sm: "flex" }, my: 2 }}>
        <Box sx={{ width: "140px" }}>
          <Typography sx={{ lineHeight: "36px" }}>募集情報（必須）</Typography>
        </Box>
        <Box sx={{ width: { xs: "100%", sm: "550px" } }}>
          <Select
            options={reversedProjectList}
            getOptionLabel={(option) => option.mail_subject || ""}
            getOptionValue={(option) => option.id}
            placeholder="募集情報を選択してください"
            onChange={handleChangeProjectID}
            value={requestedProjectForInterview.id !== 0 ? requestedProjectForInterview : null}
          />
        </Box>
      </Box>

      <Box sx={{ display: { xs: "block", sm: "flex" }, my: 2 }}>
        <Box sx={{ width: "140px" }}>
          <Typography sx={{ lineHeight: { xs: "40px", sm: "160px" } }}>
            連絡事項（任意）
          </Typography>
        </Box>
        <Box sx={{ flexGrow: 1 }}>
          <TextField
            value={message}
            onChange={(event) => setMessage(event.target.value)}
            id="outlined-multiline-static"
            placeholder="事務局への連絡"
            multiline
            rows={4}
            sx={{
              marginTop: { xs: "0px", sm: "20px" },
              backgroundColor: "white",
            }}
            fullWidth
            inputProps={{ maxLength: 200 }}
          />
        </Box>
      </Box>

      <Box display="flex" justifyContent="flex-end">
        <Typography>{message.length}/200</Typography>
      </Box>

      <Grid container direction="column" alignItems="center" sx={{ mt: 2 }}>
        <Box sx={{ width: "180px" }}>
          <NonIconButton
            title="打合せ希望連絡"
            clickEvent={requestInterview}
            disabled={!requestedProjectForInterview?.id}
          />
        </Box>
      </Grid>
    </Box>
  );
}